import { globalChannel } from "infrastructure/globalChannel";
import { TAB_ID } from "infrastructure/tabIdentity";
import { emit } from "infrastructure/eventHub";

export function init() {
  globalChannel.addEventListener("message", (message) => {
    const event = message.data;
    if (!event || event.from === TAB_ID) return;
    emit(event.domain, event.entity, event.action, "local", event.payload);
  });
}
